module.exports = __webpack_public_path__ + "img/Kinfolk-Logo-Vector.9f28df7e.svg";